import { CoreModel } from '../core/core.model';
import { FabButtonModel } from './fab-button.model';
export class FabModel extends CoreModel {
/**
 * Direction of opening Fab action buttons. Can be: up, right, down, left.
 */
direction?: string;
/**
 * FabButtonModel for the trigger fab button.
 */
trigger?: FabButtonModel;
/**
 * Array of buttons with type FabButtonModel for the action mini fab buttons.
 */
actionButtons?: FabButtonModel[];
/**
 * Whether to display action mini fab buttons on component init.
 */
showButtons?: boolean;
/**
 * Whether to not hide action mini fab buttons on click events on them.
 */
stayOpened?: boolean;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function FabModel_tsickle_Closure_declarations() {
/**
 * Direction of opening Fab action buttons. Can be: up, right, down, left.
 * @type {?}
 */
FabModel.prototype.direction;
/**
 * FabButtonModel for the trigger fab button.
 * @type {?}
 */
FabModel.prototype.trigger;
/**
 * Array of buttons with type FabButtonModel for the action mini fab buttons.
 * @type {?}
 */
FabModel.prototype.actionButtons;
/**
 * Whether to display action mini fab buttons on component init.
 * @type {?}
 */
FabModel.prototype.showButtons;
/**
 * Whether to not hide action mini fab buttons on click events on them.
 * @type {?}
 */
FabModel.prototype.stayOpened;
}

